window.OrionVariantMedia = window.OrionVariantMedia || {};
window.OrionVariantMedia.normalizeCatalog = (entries) => (Array.isArray(entries) ? entries : [])
  .filter((entry) => entry && entry.variantId)
  .map((entry) => ({ variantId: String(entry.variantId), mediaId: entry.mediaId ? String(entry.mediaId) : null,
    mediaIds: [...new Set(Array.isArray(entry.mediaIds) ? entry.mediaIds.map(String) : [])] }));
window.OrionVariantMedia.select = (catalog, variantId, featuredMediaId) => {
  const entries = window.OrionVariantMedia.normalizeCatalog(catalog);
  const selected = entries.find((entry) => entry.variantId === String(variantId || ''));
  const selectedIds = selected?.mediaIds.length ? [...selected.mediaIds] : selected?.mediaId ? [selected.mediaId] : [];
  if (!selectedIds.length && featuredMediaId) selectedIds.push(String(featuredMediaId));
  const allIds = [...new Set(entries.flatMap((entry) => [...entry.mediaIds, ...(entry.mediaId ? [entry.mediaId] : [])]))];
  const featuredId = String(featuredMediaId || '');
  return { selectedIds, allIds, primaryId: selectedIds.includes(featuredId) ? featuredId : String(selectedIds[0] || featuredId) };
};
window.OrionVariantMedia.shouldHideSupplierMedia = (mediaColorCode, selectedColorCode) =>
  Boolean(selectedColorCode) && String(mediaColorCode || '') !== String(selectedColorCode);
window.OrionVariantMedia.resolvePrimaryMediaId = (variantFeaturedMediaId, galleryMediaId) =>
  String(variantFeaturedMediaId || galleryMediaId || '');

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.isStanleyGallery = this.dataset.orionStanleyGallery === 'true';
        this.galleryVariantMedia = this.readGalleryVariantMedia();
        this.galleryVariantMediaIds = this.galleryVariantMedia.flatMap((entry) => [...entry.mediaIds, ...(entry.mediaId ? [entry.mediaId] : [])]);
        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.viewer.addEventListener('click', this.onViewerButtonClick.bind(this), true);
        this.bindThumbnailEvents();
        if (this.dataset.selectedVariantId) {
          this.setVariantMedia(this.dataset.selectedVariantMediaId, [], this.dataset.selectedVariantId);
        }
        this.syncNavigationState();
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      readGalleryVariantMedia(root = this) {
        const catalog = root.querySelector('[data-orion-gallery-variant-media]');
        if (!catalog) return [];
        try {
          return window.OrionVariantMedia.normalizeCatalog(JSON.parse(catalog.textContent || '[]'));
        } catch (_error) {
          return [];
        }
      }

      getNavigableMedia() {
        const slider = this.elements.viewer?.slider;
        if (!slider) return [];
        return Array.from(slider.children).filter((item) =>
          item.matches('li.product__media-item[data-media-id]') && !item.hidden
        );
      }

      getActiveMediaIndex() {
        const mediaItems = this.getNavigableMedia();
        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        return activeIndex >= 0 ? activeIndex : 0;
      }

      setActiveMediaByIndex(index) {
        const mediaItems = this.getNavigableMedia();
        if (!mediaItems.length) return;
        const normalizedIndex = ((index % mediaItems.length) + mediaItems.length) % mediaItems.length;
        this.setActiveMedia(mediaItems[normalizedIndex].dataset.mediaId, false);
      }

      onViewerButtonClick(event) {
        const button = event.target.closest('button[name="previous"], button[name="next"]');
        if (!button || !this.elements.viewer.contains(button)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const direction = button.name === 'next' ? 1 : -1;
        this.setActiveMediaByIndex(this.getActiveMediaIndex() + direction);
      }

      syncNavigationState() {
        const mediaItems = this.getNavigableMedia();
        const currentIndex = this.getActiveMediaIndex();
        const previousButton = this.elements.viewer?.querySelector('button[name="previous"]');
        const nextButton = this.elements.viewer?.querySelector('button[name="next"]');
        const currentCounter = this.elements.viewer?.querySelector('.slider-counter--current');
        const totalCounter = this.elements.viewer?.querySelector('.slider-counter--total');
        const disabled = mediaItems.length < 2;

        previousButton?.toggleAttribute('disabled', disabled);
        nextButton?.toggleAttribute('disabled', disabled);
        if (currentCounter) currentCounter.textContent = String(mediaItems.length ? currentIndex + 1 : 0);
        if (totalCounter) totalCounter.textContent = String(mediaItems.length);
      }

      bindThumbnailEvents() {
        if (!this.elements.thumbnails) return;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (!button || button.dataset.orionGalleryBound === 'true') return;
          button.dataset.orionGalleryBound = 'true';
          button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
      }

      refreshThumbnails(sourceGallery) {
        const sourceThumbnails = sourceGallery?.querySelector('[id^="GalleryThumbnails"]');
        const currentThumbnails = this.elements.thumbnails;

        if (!sourceThumbnails) {
          currentThumbnails?.remove();
          this.elements.thumbnails = null;
        } else {
          const replacement = sourceThumbnails.cloneNode(true);
          if (currentThumbnails) currentThumbnails.replaceWith(replacement);
          else this.append(replacement);
          this.elements.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        }
        this.galleryVariantMedia = this.readGalleryVariantMedia(sourceGallery || this);
        this.galleryVariantMediaIds = this.galleryVariantMedia.flatMap((entry) => [...entry.mediaIds, ...(entry.mediaId ? [entry.mediaId] : [])]);
        this.bindThumbnailEvents();
        this.elements.viewer?.resetPages?.();
        this.syncNavigationState();
      }

      hasSameMedia(sourceGallery) {
        if (!sourceGallery) return false;
        // Ignore DOM order and selection classes: Shopify renders the selected image first.
        const signature = (root) => JSON.stringify(Array.from(root.querySelectorAll('li[data-media-id], li[data-target]'))
          .map((item) => [item.dataset.mediaId || item.dataset.target, item.hasAttribute('data-target'),
            item.dataset.orionColorCode || '', item.dataset.orionSupplierMedia || '',
            Array.from(item.querySelectorAll('img')).map((img) =>
              ['src', 'srcset', 'sizes', 'alt'].map((attribute) => img.getAttribute(attribute)))])
          .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
        return signature(this) === signature(sourceGallery)
          && JSON.stringify(this.galleryVariantMedia) === JSON.stringify(this.readGalleryVariantMedia(sourceGallery));
      }

      setVariantMedia(featuredMediaId, variantMediaIds, variantId) {
        if (!this.elements.viewer) return null;
        const selectedVariantId = String(variantId || this.galleryVariantMedia.find((entry) =>
          entry.mediaId === String(featuredMediaId || '') || entry.mediaIds.includes(String(featuredMediaId || ''))
        )?.variantId || this.dataset.selectedVariantId || '');
        const selection = window.OrionVariantMedia.select(this.galleryVariantMedia, selectedVariantId, featuredMediaId);
        const selectedGroupIds = new Set(selection.selectedIds);
        // The second argument lists ALL variant images, not images of the selected color.
        const allVariantIds = new Set([...selection.allIds, ...(variantMediaIds || []).map(String)]);
        const selectedId = selection.primaryId || this.getNavigableMedia()[0]?.dataset.mediaId?.split('-').pop();
        if (!selectedId) return null;
        this.dataset.selectedVariantMediaId = selectedId;
        this.dataset.selectedVariantId = selectedVariantId;
        this.activeVariantMediaId = selectedId;
        this.activeVariantId = selectedVariantId;
        this.variantMediaIds = Array.from(allVariantIds);
        this.selectedVariantMediaIds = Array.from(selectedGroupIds);
        // The next color is hidden until this update. Search all slides before filtering.
        const selectedSlide = Array.from(this.elements.viewer.slider?.querySelectorAll('li[data-media-id]') || [])
          .find((item) => String(item.dataset.mediaId || '').endsWith(`-${selectedId}`));
        this.selectedColorCode = selectedSlide?.dataset.orionColorCode || '';
        const thumbnailList = this.elements.thumbnails?.querySelector('[id^="Slider-Thumbnails"]');

        this.elements.viewer?.slider?.querySelectorAll(':scope > li.product__media-item[data-media-id]').forEach((item) => {
          const mediaId = String(item.dataset.mediaId || '').split('-').pop();
          const wrongSupplierColor = this.isStanleyGallery && item.dataset.orionSupplierMedia === 'true' && window.OrionVariantMedia.shouldHideSupplierMedia(item.dataset.orionColorCode, this.selectedColorCode);
          item.toggleAttribute('hidden', wrongSupplierColor || allVariantIds.has(mediaId) && !selectedGroupIds.has(mediaId));
        });

        let selectedThumbnail = Array.from(thumbnailList?.querySelectorAll('[data-target]') || []).find((item) =>
          String(item.dataset.target || '').endsWith(`-${selectedId}`)
        );

        if (!selectedThumbnail) {
          const activeMedia = this.getNavigableMedia().find((item) =>
            String(item.dataset.mediaId || '').endsWith(`-${selectedId}`)
          );
          const sourceImage = activeMedia?.querySelector('img');
          const template = thumbnailList?.querySelector('[data-target]');
          if (activeMedia && sourceImage && template) {
            selectedThumbnail = template.cloneNode(true);
            selectedThumbnail.dataset.target = activeMedia.dataset.mediaId;
            selectedThumbnail.id = `Slide-Thumbnails-${activeMedia.dataset.mediaId}`;
            selectedThumbnail.removeAttribute('hidden');
            selectedThumbnail.querySelectorAll('.thumbnail__badge').forEach((badge) => badge.remove());
            const button = selectedThumbnail.querySelector('button');
            const image = selectedThumbnail.querySelector('img');
            if (button) {
              button.removeAttribute('data-orion-gallery-bound');
              button.setAttribute('aria-label', sourceImage.alt || 'Afficher le média sélectionné');
              button.removeAttribute('aria-current');
            }
            if (image) {
              image.id = `Thumbnail-${activeMedia.dataset.mediaId}`;
              image.src = sourceImage.currentSrc || sourceImage.src;
              image.srcset = sourceImage.srcset || '';
              image.alt = sourceImage.alt || '';
              button?.setAttribute('aria-describedby', image.id);
            }
            thumbnailList.prepend(selectedThumbnail);
          }
        }

        thumbnailList?.querySelectorAll('[data-target]').forEach((item) => {
          const mediaId = String(item.dataset.target || '').split('-').pop();
          const wrongSupplierColor = this.isStanleyGallery && item.dataset.orionSupplierMedia === 'true' && window.OrionVariantMedia.shouldHideSupplierMedia(item.dataset.orionColorCode, this.selectedColorCode);
          item.toggleAttribute('hidden', wrongSupplierColor || allVariantIds.has(mediaId) && !selectedGroupIds.has(mediaId));
          if (!item.hidden) item.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
        });

        if (selectedThumbnail) thumbnailList.prepend(selectedThumbnail);
        this.bindThumbnailEvents();
        const selectedMedia = this.getNavigableMedia().find((item) =>
          String(item.dataset.mediaId || '').endsWith(`-${selectedId}`)
        );
        if (selectedMedia) {
          this.getNavigableMedia().forEach((item) => item.classList.toggle('is-active', item === selectedMedia));
        }
        this.elements.thumbnails?.resetPages?.();
        this.elements.viewer?.resetPages?.();
        this.syncNavigationState();
        this.filterModalMedia(this.selectedColorCode);
        const active = this.getNavigableMedia().find((item) => String(item.dataset.mediaId || '').endsWith(`-${selectedId}`));
        return active?.dataset.mediaId || null;
      }

      filterModalMedia(colorCode) {
        const modal = document.querySelector(`#ProductModal-${this.id.replace('MediaGallery-', '')} .product-media-modal__content`);
        if (!modal) return;
        const allIds = new Set(this.variantMediaIds || []);
        const selectedIds = new Set(this.selectedVariantMediaIds || []);
        modal.querySelectorAll(':scope > [data-media-id]').forEach((item) => {
          const wrongColor = this.isStanleyGallery && item.dataset.orionSupplierMedia === 'true'
            && window.OrionVariantMedia.shouldHideSupplierMedia(item.dataset.orionColorCode, colorCode);
          item.toggleAttribute('hidden', wrongColor || allIds.has(String(item.dataset.mediaId)) && !selectedIds.has(String(item.dataset.mediaId)));
        });
      }

      onSlideChanged(event) {
        if (!event.detail.currentElement?.dataset?.mediaId) return;
        if (event.detail.currentElement.hidden || !this.elements.viewer.contains(event.detail.currentElement)) return;
        this.elements.viewer.querySelectorAll('li.product__media-item[data-media-id]').forEach((element) => {
          element.classList.toggle('is-active', element === event.detail.currentElement);
        });
        if (!this.elements.thumbnails) {
          this.syncNavigationState();
          return;
        }
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.syncNavigationState();
      }

      setActiveMedia(mediaId, prepend) {
        const mediaItems = this.getNavigableMedia();
        const activeMedia = mediaItems.find((item) => item.dataset.mediaId === mediaId) || mediaItems[0];
        if (!activeMedia) {
          return;
        }
        activeMedia.classList.add('scroll-trigger--cancel');
        mediaItems.forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (this.mql.matches) {
          activeMedia.parentElement.scrollLeft = 0;
          window.requestAnimationFrame(() => {
            activeMedia.parentElement.scrollLeft = 0;
          });
        }

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.syncNavigationState();
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        const announce = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        if (image.complete) announce();
        else image.addEventListener('load', announce, { once: true });
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
